import { Button, Icon, Tooltip } from 'bold-ui'
import { useHistory } from 'react-router'

interface VisualizarPaginaButtonProps {
  path?: string
  tooltipText: string
  disabled?: boolean
  onClick?: () => void
}

export const VisualizarPaginaButton = (props: VisualizarPaginaButtonProps) => {
  const { path, tooltipText, disabled, onClick } = props
  const history = useHistory()

  const handleOnClick = () => {
    history.push(path)
  }

  return (
    <Tooltip text={tooltipText}>
      <Button type='button' skin='ghost' size='small' disabled={disabled} onClick={onClick ?? handleOnClick}>
        <Icon icon='zoomOutline' />
      </Button>
    </Tooltip>
  )
}
